import { lsGet, safeAwait } from 'utils/request'

export const getLayoutModuleById = (moduleId) => {
  return safeAwait(lsGet(`/layoutModules/${moduleId}`))
}
